/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fleet_Camera_Live_StartInputs */

const vi_fleet_camera_live_start = /** @type {(inputs: Fleet_Camera_Live_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xem trực tiếp`)
};

/**

* @param {Fleet_Camera_Live_StartInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const fleet_camera_live_start = /** @type {((inputs?: Fleet_Camera_Live_StartInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fleet_Camera_Live_StartInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_fleet_camera_live_start(inputs)
});